import { Component, OnInit } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MainRoute, RootRoute } from '../../../../../shared/models/angular-routing';
import { StormPanelComponent } from '../storm-panel/storm-panel.component';
import { MapPreviewComponent } from '../../../../../shared/components/map-preview/map-preview.component';
import { InsightsRoute } from '../../../insights-routing.module';
import { StormMapContent } from '../../../../../shared/components/map-preview/model/map-content/StormMapContent';
import { ConfigurationService } from '../../../../../configuration/configuration.service';
import { StormControlComponent } from '../storm-control/storm-control.component';
import { filter } from 'rxjs/operators';
import { StormInfo, StormShift, toStormInfo } from '../../../../../shared/models/storm.model';
import { StormService } from '../../../../../data/storms/storm.service';
import { StormMapDataService } from '../storm-map-data.service';
import { ConfigurationModel } from '../../../../../shared/models/configuration.model';

@Component({
  selector: 'app-storm-detail',
  imports: [MatButton, MatIcon, MatIconButton, MatTooltip, StormPanelComponent, MapPreviewComponent, StormControlComponent, RouterOutlet],
  templateUrl: './storm-detail.component.html',
  styleUrl: './storm-detail.component.scss',
})
export class StormDetailComponent implements OnInit {
  isLoading = false;
  showingShiftDetail = false;
  stormId!: number;
  storm: StormInfo;
  stormShifts: StormShift[];
  configuration: ConfigurationModel;

  mapContent: StormMapContent;
  filterUnixTime: number;
  speedFactor = 10;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly configurationService: ConfigurationService,
    private readonly stormService: StormService,
    private readonly stormMapDataService: StormMapDataService,
  ) {}

  ngOnInit() {
    this.stormId = this.activatedRoute.snapshot.params['stormId'];
    this.showingShiftDetail = this.router.url.includes('(shift:');

    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe(() => {
      this.showingShiftDetail = this.router.url.includes('(shift:');
    });

    this.configurationService.sharedConfigurationModel.subscribe(model => {
      if (model !== null) {
        this.configuration = model;
        // hit access to get signing cookie (only AWS env)
        this.stormService.getStormAccess(this.stormId).then(() => {
          Promise.all([
            this.stormService.getStorm(this.stormId),
            this.stormService.getStormShifts(this.stormId),
            model,
            this.stormService.getStormPlaybackIndex(model.id, this.stormId),
          ]).then(responses => {
            const [storm, stormShifts, configuration, playbackIndex] = responses;
            this.storm = toStormInfo(storm.data);
            this.stormShifts = stormShifts.data;

            this.mapContent = new StormMapContent(
              configuration,
              this.configurationService.trackStyles,
              this.stormShifts,
              this.storm,
              playbackIndex,
              this.stormMapDataService,
              (unixtime: number) => {
                this.currentTimeChanged(unixtime);
              }
            );
          }).catch(error => {
            console.error(error);
          });
        }).catch(error => {
          console.error(error);
        });
      }
    });
  }

  goBack() {
    this.router
      .navigate(['../..', InsightsRoute.STORM_REPORT], {
        relativeTo: this.activatedRoute,
      })
      .then();
  }

  closeInsight() {
    this.router
      .navigate([`/${RootRoute.MAIN}`, MainRoute.INSIGHTS], {
        queryParamsHandling: 'merge',
        queryParams: { search: undefined, address: undefined, visit: undefined },
      })
      .then();
  }

  filter(timeTo: number) {
    this.filterUnixTime = timeTo;
    this.mapContent?.filterTo(timeTo);
  }

  onSpeedUpdate(speed: number) {
    this.speedFactor = speed;
    this.mapContent.changeAnimationSpeed(this.speedFactor);
  }

  // Storm Map Content changed
  currentTimeChanged(unixTime: number) {
    this.filterUnixTime = unixTime;
  }
}
